module.exports = __webpack_public_path__ + "static/img/xxtj.ffd4c38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/dynamicRoute4/dataAnalysis/img/xxtj.jpg
// module id = JAF0
// module chunks = 157